export const en = {
  'brand.name': 'Zertteu Academy',
  'brand.tagline': 'Research CRM Platform',

  'common.open': 'Открыть →',
  'common.error': 'Произошла ошибка',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.profile': 'Профиль',
  'common.back': '← Назад',
  'common.close': 'Закрыть ×',
  'common.all': 'Все',
  'common.search': 'Поиск',
  'common.reset': 'Сбросить',
  'common.loading': 'Загрузка',
  'common.notFound': 'Ничего не найдено',
  'common.updatedJustNow': 'Обновлено только что',
  'common.demoMode': 'Демонстрационный режим',

  'a11y.openMenu': 'Открыть меню роли',
  'a11y.closeMenu': 'Закрыть меню',
  'a11y.language': 'Выбор языка',
  'a11y.theme': 'Выбор темы',
  'a11y.socials': 'Социальные сети',
  'a11y.slider': 'Слайдер новостей',
  'a11y.gotoSlide': 'Перейти к слайду',

  'theme.system': 'Системная тема',
  'theme.light': 'Светлая тема',
  'theme.dark': 'Тёмная тема',

  'topbar.account': 'Профиль',
  'topbar.account.id': 'Academia ID',
  'topbar.account.roles': 'Роли',
  'topbar.signIn': 'Войти',
  'topbar.signOut': 'Выйти',

  'nav.home': 'Главная',
  'nav.about': 'О нас',
  'nav.about.mission': 'Миссия и платформа',
  'nav.about.structure': 'Структура',
  'nav.about.founder': 'О создателе',
  'nav.about.achievements': 'Достижения',
  'nav.about.legal': 'Нормативная база',
  'nav.news': 'Новости',
  'nav.news.events': 'События платформы',
  'nav.news.science': 'Новости науки',
  'nav.news.media': 'СМИ о проекте',
  'nav.news.updates': 'Обновления',
  'nav.competitions': 'Конкурсы',
  'nav.competitions.science': 'Образование и наука',
  'nav.competitions.culture': 'Культура и искусство',
  'nav.competitions.society': 'Общество и инновации',
  'nav.competitions.sport': 'Спорт',
  'nav.materials': 'Материалы',
  'nav.materials.announcements': 'Объявления',
  'nav.materials.templates': 'Образцы документов',
  'nav.materials.tests': 'Тесты',
  'nav.materials.books': 'Книги и пособия',
  'nav.education': 'Образование',
  'nav.education.institutions': 'Учебные заведения',
  'nav.education.grants': 'Гранты и стипендии',
  'nav.education.internships': 'Стажировки',
  'nav.education.courses': 'Курсы',
  'nav.vacancies': 'Вакансии',
  'nav.vacancies.teaching': 'Педагогика и наука',
  'nav.vacancies.it': 'IT и технологии',
  'nav.vacancies.all': 'Все направления',
  'nav.contacts': 'Контакты',
  'nav.instructions': 'Инструкция',

  'drawer.title': 'Меню кабинета',
  'drawer.role.anonymous': 'Гость',
  'drawer.roles': 'Роли кабинета',
  'drawer.group.home': 'Главная',
  'drawer.group.requests': 'Заявки',
  'drawer.group.publications': 'Публикации',
  'drawer.group.education': 'Образование',
  'drawer.group.tools': 'Инструменты',
  'drawer.group.admin': 'Администрирование',
  'drawer.link.overview': 'Обзор',
  'drawer.link.requests': 'Заявки',
  'drawer.link.newRequest': 'Новая заявка',
  'drawer.link.journals': 'Журналы',
  'drawer.link.publicationPlan': 'План публикаций',
  'drawer.link.learners': 'Докторанты',
  'drawer.link.supervision': 'Научное руководство',
  'drawer.link.assistant': 'AI Assistant',
  'drawer.link.glossary': 'Глоссарий KZ/RU/EN',
  'drawer.link.audit': 'Аудит',
  'drawer.link.security': 'Безопасность',

  'workspace.label': 'Рабочее пространство:',
  'workspace.labelShort': 'Роль:',
  'workspace.owner': 'Владелец',
  'workspace.ownerFull': 'Владелец системы',
  'workspace.operations': 'Операционный партнёр',
  'workspace.mentor': 'Наставник',
  'workspace.learner': 'Обучающийся',
  'workspace.status.online': 'Онлайн',
  'workspace.superAi': 'Super AI →',
  'workspace.createRequest': 'Создать заявку',
  'workspace.partner.breadcrumb': 'Кабинет научного партнёра',
  'workspace.partner.title': 'Научный партнёр / коллега',
  'workspace.partner.text': 'Центр научных заявок, проектов, академических связей и заказов клиентов',
  'workspace.departmentHead.breadcrumb': 'Кабинет кафедры',
  'workspace.departmentHead.title': 'Руководитель подразделения',
  'workspace.departmentHead.text': 'Кафедральный центр: контроль докторантуры, сотрудники, нагрузка, документы и встречи',
  'workspace.departmentLab.title': 'Лаборант кафедры',
  'workspace.owner.breadcrumb': 'Кабинет владельца',
  'workspace.owner.title': 'Владелец системы',
  'workspace.owner.text': '10 центральных модулей управления платформой',
  'workspace.advisor.breadcrumb': 'Кабинет эдвайзера',
  'workspace.advisor.title': 'Эдвайзер',
  'workspace.advisor.text': '12 модулей учебного процесса докторантов',
  'workspace.supervisor.breadcrumb': 'Кабинет научного руководителя',
  'workspace.supervisor.title': 'Научный руководитель',
  'workspace.supervisor.text': '8 модулей научного руководства и совместных проектов',
  'workspace.teacher.breadcrumb': 'Кабинет преподавателя',
  'workspace.teacher.title': 'Преподаватель',
  'workspace.teacher.text': 'Учебный процесс, электронный журнал, посещаемость и научные проекты',
  'workspace.researcher.breadcrumb': 'Кабинет исследователя',
  'workspace.researcher.title': 'Исследователь',
  'workspace.researcher.text': '9 модулей научной деятельности и публикаций',
  'workspace.doctoral.breadcrumb': 'Кабинет докторанта',
  'workspace.doctoral.title': 'Докторант',
  'workspace.doctoral.text': '14 модулей учебного и исследовательского процесса PhD',
  'workspace.student.breadcrumb': 'Кабинет обучающегося под руководством',
  'workspace.student.title': 'Обучающийся под руководством',
  'workspace.student.text': '10 модулей индивидуального научного руководства',
  'workspace.courseStudent.breadcrumb': 'Кабинет обучающегося',
  'workspace.courseStudent.title': 'Обучающийся',
  'workspace.courseStudent.text': 'Учебный процесс, дисциплины, задания, журнал оценок, посещаемость и проекты',
  'workspace.author.breadcrumb': 'Кабинет автора и соавтора',
  'workspace.author.title': 'Автор / Соавтор',
  'workspace.author.text': 'Модуль научной деятельности, публикаций и поиска соавторов',
  'workspace.client.breadcrumb': 'Кабинет клиента',
  'workspace.client.title': 'Клиент',
  'workspace.client.text': 'Модуль научно-академических заявок, проектов и сервисов',
  'workspace.editor.breadcrumb': 'Кабинет редактора проекта',
  'workspace.editor.title': 'Редактор проекта',
  'workspace.editor.text': 'Модуль управления редакционными объектами, экспертизой и публикациями',
  'workspace.projectMember.breadcrumb': 'Кабинет участника проекта',
  'workspace.projectMember.title': 'Участник проекта',
  'workspace.projectMember.text': 'Модуль научного сотрудничества, академических задач и инструментов',
  'workspace.col.title': 'Название',
  'workspace.col.kind': 'Тип',
  'workspace.col.size': 'Размер',
  'workspace.col.requester': 'Заявитель',
  'workspace.col.service': 'Услуга',
  'workspace.col.status': 'Статус',
  'workspace.col.assignee': 'Исполнитель',
  'workspace.col.name': 'ФИО',
  'workspace.col.program': 'Программа',
  'workspace.col.year': 'Курс',
  'workspace.col.rating': 'Рейтинг',
  'workspace.col.details': 'Детали',
  'workspace.monitoring.total': 'Всего докторантов',
  'workspace.monitoring.defended': 'Защитились',
  'workspace.monitoring.years': 'По годам',
  'workspace.points.rules': 'Правила',
  'workspace.points.ledger': 'Операции',
  'workspace.tab.registry': 'Реестр',
  'workspace.tab.preliminary': 'Предварительные ответы',
  'workspace.tab.connections': 'Академические связи',
  'workspace.tab.mail': 'Почта',
  'workspace.tab.decisions': 'Решения',
  'workspace.tab.audit': 'Аудит',
  'workspace.tab.users': 'Пользователи',
  'workspace.tab.access_requests': 'Заявки на доступ',
  'workspace.tab.invite': 'Приглашение',
  'workspace.tab.matrix': 'Матрица',
  'workspace.tab.toolbox': 'Инструменты',
  'workspace.tab.surveys': 'Опросы',
  'workspace.tab.author': 'Авторские обращения',
  'workspace.tab.clients': 'Заказы клиентов',
  'workspace.tab.shared': 'Совместные статьи',
  'workspace.tab.overview': 'Обзор',
  'workspace.tab.year_1': '1 курс',
  'workspace.tab.year_2': '2 курс',
  'workspace.tab.year_3': '3 курс',
  'workspace.tab.templates': 'Образцы',
  'workspace.tab.years': 'По годам',
  'workspace.tab.supervisors': 'Руководители',
  'workspace.tab.semesters': 'Семестры',
  'workspace.tab.inbox': 'Входящие',
  'workspace.tab.rating': 'Рейтинг',
  'workspace.tab.rules': 'Правила',
  'workspace.tab.manual': 'Ручная корректировка',
  'workspace.tab.services': 'Стоимость услуг',
  'workspace.tab.library': 'Библиотека',
  'workspace.tab.sources': 'Источники',
  'workspace.tab.all': 'Все',
  'workspace.tab.bachelor': 'Бакалавриат',
  'workspace.tab.master': 'Магистратура',
  'workspace.tab.doctoral': 'Докторантура',
  'workspace.tab.pending': 'Ожидают',
  'workspace.tab.approved': 'Одобрено',
  'workspace.tab.rejected': 'Отклонено',
  'workspace.tab.active': 'Активные',
  'workspace.tab.archive': 'Архив',
  'workspace.tab.published': 'Опубликовано',
  'workspace.tab.in_review': 'На рецензии',
  'workspace.tab.completed': 'Завершено',
  'workspace.tab.applications': 'Заявки',
  'workspace.tab.journals': 'Журналы',
  'workspace.tab.conferences': 'Конференции',
  'workspace.tab.articles': 'Статьи',
  'workspace.tab.grants': 'Гранты',
  'workspace.tab.events': 'Мероприятия',
  'workspace.tab.students': 'Обучающиеся',
  'workspace.tab.topics': 'Темы',
  'workspace.tab.plans': 'Планы и задачи',
  'workspace.tab.documents': 'Документы',
  'workspace.tab.nir': 'Публикации / НИР',
  'workspace.tab.deadlines': 'Сроки / практика',
  'workspace.tab.consultations': 'Консультации',
  'workspace.tab.defense': 'Предзащита / защита',
  'workspace.tab.literature': 'Литература',
  'workspace.tab.thesis': 'Основная работа',
  'workspace.tab.experiments': 'Эксперименты',
  'workspace.tab.analysis': 'Анализ данных',
  'workspace.tab.topic': 'Тема и роль',
  'workspace.tab.plan': 'План и этапы',
  'workspace.tab.tasks': 'Задачи и материалы',
  'workspace.tab.meetings': 'Встречи и консультации',
  'workspace.tab.results': 'Презентации и результаты',
  'workspace.researcher.profile.bio': 'Биография',
  'workspace.researcher.profile.interests': 'Интересы',
  'workspace.researcher.profile.ids': 'Идентификаторы',

  'home.eyebrow': 'Научно-образовательная цифровая платформа',
  'home.subtitle':
    'Единая среда для научных проектов, публикаций, авторов, докторантов и интеллектуальных исследовательских инструментов.',
  'home.side.eyebrow': 'Интеллектуальная инфраструктура',
  'home.side.title': 'От исследовательской идеи — к проверенному результату',
  'home.side.text':
    'Управление знаниями, публикациями, научным руководством и аналитикой в едином защищённом пространстве.',
  'home.side.point.crm': 'CRM',
  'home.side.point.publications': 'Публикации',
  'home.side.point.analytics': 'Аналитика',
  'home.core.title': 'ZERTTEU INTELLIGENCE CORE',
  'home.core.subtitle': 'Research · Metadata · Analytics',

  'ticker.label': 'Срочно',
  'ticker.item1': 'Приём заявок на грант открыт до 30 сентября',
  'ticker.item2': 'Обновлён модуль аналитики публикаций',
  'ticker.item3': 'Регистрация на конференцию продлена',

  'feed.title': 'Рабочая лента',
  'feed.badge': 'New',
  'feed.source.owner': 'Владелец',
  'feed.source.mentor': 'Наставник',
  'feed.source.author': 'Автор',
  'feed.source.department': 'Отдел',
  'feed.item1': 'Обновление регламента приёма заявок',
  'feed.item2': 'Новый цикл научного руководства',
  'feed.item3': 'Публикация принята в печать',
  'feed.item4': 'Итоги квартального отчёта',

  'slide.1.kicker': 'Academic Research CRM',
  'slide.1.title': 'Управляйте наукой в едином цифровом пространстве',
  'slide.1.text':
    'Заявки, публикации, научное руководство и аналитика — под одним интерфейсом с ролевым доступом.',
  'slide.1.primary': 'Подать заявку',
  'slide.1.secondary': 'Узнать больше',
  'slide.2.kicker': 'Гранты и стипендии',
  'slide.2.title': 'Находите возможности для роста быстрее',
  'slide.2.text':
    'Единый каталог грантов, стажировок и стипендий с фильтрами по направлению и уровню.',
  'slide.2.primary': 'Смотреть каталог',
  'slide.2.secondary': 'Подписаться',
  'slide.3.kicker': 'Научное руководство',
  'slide.3.title': 'Прозрачное сопровождение докторантов',
  'slide.3.text':
    'Треки защит, контрольные точки и коммуникация с наставником — в одном рабочем пространстве.',
  'slide.3.primary': 'Перейти в кабинет',
  'slide.3.secondary': 'Расписание',
  'slide.cta.cabinet': 'Go to cabinet',
  'slide.cta.schedule': 'Schedule',

  'digest.tab.fresh': 'Latest',
  'digest.tab.important': 'Important',
  'digest.tab.pending': 'Trends',
  'digest.kind.event': 'Событие',
  'digest.kind.important': 'Важно',
  'digest.kind.news': 'Новость',
  'digest.kind.waiting': 'Ожидает',
  'digest.item1': 'Открыт приём тезисов конференции',
  'digest.item2': 'Обновлены требования к оформлению',
  'digest.item3': 'Партнёрство с научным центром',
  'digest.item4': 'Заявка №0231 ожидает подтверждения',
  'digest.ago.days2': '2 дня назад',
  'digest.ago.days4': '4 дня назад',
  'digest.ago.week': 'Неделю назад',
  'digest.ago.today': 'Сегодня',

  'pending.label': 'Pending',
  'pending.item1': 'Заявка №0231 — на рассмотрении',
  'pending.item2': 'Публикация — проверка редактора',
  'pending.item3': 'Стажировка — подтверждение документов',

  'quickActions.title': 'Быстрые действия',
  'quickActions.text': 'Наиболее востребованные разделы платформы для всех ролей.',
  'quickActions.roles': '8 ролей',
  'quickActions.sections': '24 раздела',
  'quickActions.languages': '3 языка',
  'quickActions.request': 'Подать заявку',
  'quickActions.requestText': 'Форма создания и отслеживания заявок',
  'quickActions.publications': 'Публикации',
  'quickActions.publicationsText': 'Каталог и статус научных работ',
  'quickActions.calendar': 'Календарь',
  'quickActions.calendarText': 'Мероприятия и контрольные точки',
  'quickActions.assistant': 'AI-консультант',
  'quickActions.assistantText': 'Ответы на вопросы по платформе',

  'dashboard.eyebrow': 'Личный кабинет',
  'dashboard.title': 'Панель управления — {role}',
  'dashboard.today': 'Сегодня',
  'dashboard.todayTitle': '{count} заявки на рассмотрении',
  'dashboard.todayText': '2 публикации ожидают проверки редактора.',
  'dashboard.breadcrumb': 'Кабинет / Обзор',
  'dashboard.overviewTitle': 'Обзор системы',
  'dashboard.overviewText':
    'Сводные показатели по заявкам, публикациям и научному руководству за текущий период.',
  'dashboard.accessLevel': 'Уровень доступа: полный',
  'dashboard.stat.requests': 'Активные заявки',
  'dashboard.stat.publications': 'Публикации',
  'dashboard.stat.learners': 'Докторанты',
  'dashboard.stat.attention': 'Требует внимания',
  'dashboard.tab.overview': 'Обзор',
  'dashboard.tab.requests': 'Заявки',
  'dashboard.tab.publications': 'Публикации',
  'dashboard.tab.people': 'Люди',
  'dashboard.actions': 'Действия',
  'dashboard.actionsHint': 'Часто используемое',
  'dashboard.action.newRequest': 'Новая заявка',
  'dashboard.action.newRequestText': 'Создать и назначить куратора',
  'dashboard.action.review': 'Проверить публикацию',
  'dashboard.action.reviewText': 'Очередь редактора',
  'dashboard.action.report': 'Сформировать отчёт',
  'dashboard.action.reportText': 'Экспорт по периодам',
  'dashboard.action.mentor': 'Назначить наставника',
  'dashboard.action.mentorText': 'Подбор по направлению',
  'dashboard.timeline': 'Хронология',
  'dashboard.timeline.1': 'Заявка №0231 передана куратору',
  'dashboard.timeline.2': 'Публикация принята в печать',
  'dashboard.timeline.3': 'Новый докторант зарегистрирован',
  'dashboard.timeline.4': 'Обновлён регламент оформления',
  'dashboard.time.min10': '10 минут назад',
  'dashboard.time.hour1': '1 час назад',
  'dashboard.time.yesterday': 'Вчера',
  'dashboard.time.days2': '2 дня назад',
  'dashboard.team': 'Команда',
  'dashboard.teamCount': '{count} человек',
  'dashboard.role.curator': 'Куратор направлений',
  'dashboard.role.mentor': 'Научный наставник',
  'dashboard.role.editor': 'Редактор публикаций',
  'dashboard.role.admin': 'Администратор отдела',
  'dashboard.requestsTitle': 'Реестр заявок',
  'dashboard.publicationsTitle': 'Публикации',
  'dashboard.peopleTitle': 'Справочник людей',

  'requests.form.title': 'Новая заявка',
  'requests.form.hint': 'Все поля обязательны, кроме комментария',
  'requests.form.topic': 'Тема исследования',
  'requests.form.topicPlaceholder': 'Например, анализ данных...',
  'requests.form.direction': 'Направление',
  'requests.form.deadline': 'Срок',
  'requests.form.comment': 'Комментарий',
  'requests.form.commentPlaceholder': 'Краткое описание',
  'requests.form.submit': 'Отправить заявку',
  'requests.form.submitted': 'Заявка отправлена',
  'requests.direction.natural': 'Естественные науки',
  'requests.direction.humanities': 'Гуманитарные науки',
  'requests.direction.technical': 'Технические науки',
  'requests.error.topic': 'Укажите тему исследования (минимум 6 символов)',
  'requests.error.deadline': 'Выберите срок',
  'requests.error.deadlinePast': 'Срок не может быть в прошлом',

  'table.code': 'Код',
  'table.topic': 'Тема',
  'table.direction': 'Направление',
  'table.owner': 'Ответственный',
  'table.status': 'Статус',
  'table.updated': 'Обновлено',
  'table.title': 'Название',
  'table.journal': 'Журнал',
  'table.indexed': 'Индексация',
  'table.year': 'Год',
  'table.name': 'Имя',
  'table.role': 'Роль',

  'status.draft': 'Черновик',
  'status.review': 'На рассмотрении',
  'status.approved': 'Принято',
  'status.rejected': 'Отклонено',

  'consultant.eyebrow': 'Research AI',
  'consultant.title': 'Интеллектуальный научный ассистент',
  'consultant.subtitle':
    'Отвечает на вопросы по платформе, помогает с оформлением заявок и поиском материалов.',
  'consultant.side.eyebrow': 'Возможности',
  'consultant.side.title': 'Быстрые ответы 24/7',
  'consultant.side.point1': 'Заявки',
  'consultant.side.point2': 'Публикации',
  'consultant.side.point3': 'Гранты',
  'consultant.core': 'Research AI',
  'consultant.status': 'Online',
  'consultant.introTitle': 'Чем я могу помочь?',
  'consultant.introText':
    'Я — интерфейс AI-консультанта платформы. Подскажу по разделам, оформлению заявок и поиску материалов.',
  'consultant.capability1': 'Помощь с оформлением заявки',
  'consultant.capability2': 'Поиск по базе публикаций',
  'consultant.capability3': 'Подсказки по грантам и стажировкам',
  'consultant.capability4': 'Навигация по разделам платформы',
  'consultant.launcher': 'Scientific online AI consultant',
  'consultant.you': 'Вы',
  'consultant.assistant': 'AI-консультант',
  'consultant.placeholder': 'Введите сообщение...',
  'consultant.send': 'Отправить',
  'consultant.file': 'Файл',
  'mobile.nav.label': 'Mobile navigation',
  'mobile.nav.home': 'Home',
  'mobile.nav.work': 'Work',
  'mobile.nav.calendar': 'Calendar',
  'mobile.nav.chat': 'Chat',
  'mobile.nav.profile': 'Profile',
  'consultant.greeting': 'Здравствуйте! Как я могу помочь вам сегодня?',
  'consultant.typing': 'Печатает…',
  'consultant.reply.request':
    'Чтобы подать заявку, откройте «Кабинет → Новая заявка», заполните тему и направление, затем отправьте форму — куратор получит уведомление.',
  'consultant.reply.grant':
    'Перейдите в раздел «Образование → Гранты и стипендии» и выберите подходящую программу — форма заявки откроется автоматически.',
  'consultant.reply.publication':
    'Статусы публикаций доступны в разделе «Публикации». Там же видна очередь проверки редактора и индексация.',
  'consultant.reply.default':
    'Уточните, пожалуйста, раздел или задачу — я подскажу, где найти нужную информацию на платформе.',

  'auth.brandTitle': 'Research and education digital platform',
  'auth.brandText':
    'A unified space for research requests, publications, learning, projects and academic connections.',
  'auth.brandMark': 'Academic Research CRM',
  'auth.proof1': 'Access by owner invitation',
  'auth.proof2': 'Sign in with Email or Academia ID',
  'auth.proof3': 'Email verification before request',
  'auth.tab.login': 'Sign in',
  'auth.tab.register': 'Request access',
  'auth.tab.forgot': 'Recovery',
  'auth.tab.pending': 'Pending',
  'auth.tab.denied': 'Denied',
  'auth.login.title': 'Sign in',
  'auth.login.text':
    'Closed research and education platform. Access is granted only by invitation or owner approval.',
  'auth.email': 'Email',
  'auth.emailOrId': 'Email or Academia ID',
  'auth.password': 'Password',
  'auth.remember': 'Remember me',
  'auth.forgotLink': 'Forgot password?',
  'auth.submitLogin': 'Sign in',
  'auth.createAccount': 'Request access',
  'auth.requestAccess': 'Request access',
  'auth.classroom.title': 'Classroom',
  'auth.classroom.text': 'Secure classroom board · QR, teacher device and PIN',
  'auth.classroom.hint': 'Classroom entry opens from the teacher device (QR + PIN).',
  'auth.classroom.entryText':
    'Teacher confirmation for the interactive board. This is not personal cabinet login.',
  'auth.classroom.room': 'Room (optional)',
  'auth.classroom.qrLabel': 'Teacher QR (one-time challenge)',
  'auth.classroom.ttl': 'Refresh in {seconds} s',
  'auth.classroom.pin': 'Six-digit PIN',
  'auth.classroom.pinError': 'Enter exactly 6 digits',
  'auth.classroom.confirm': 'Confirm and open board',
  'auth.classroom.confirmed': 'Board opened · {name}',
  'auth.classroom.denied': 'Confirmation denied',
  'auth.classroom.todayTitle': 'Today',
  'auth.classroom.close': 'Close classroom mode',
  'auth.classroom.emptyToday': 'No lessons today. Manual course selection can be added later.',
  'auth.classroom.startLesson': 'Start lesson',
  'auth.classroom.started': 'Lesson started · {title}',
  'auth.classroom.backToday': 'Back to schedule',
  'auth.classroom.endLesson': 'End lesson',
  'auth.classroom.sessionNote':
    'CLASSROOM_ONLY mode: personal cabinet, profile and private routes are unavailable.',
  'auth.note': 'After owner approval you will receive an invitation by email.',
  'auth.register.title': 'Access request',
  'auth.register.text':
    'This is an access request, not automatic registration. First select the requested category.',
  'auth.emailPlaceholder': 'name@example.com',
  'auth.passwordPlaceholder': "At least 6 characters",
  'auth.confirmEmail': 'I confirm this email address',
  'auth.roleAssignment': 'Role assignment',
  'auth.roleAssignmentText': '— only the system owner assigns a role after review.',
  'auth.submitRegister': 'Verify email',
  'auth.backToLogin': '← Back',
  'auth.forgot.title': 'Password recovery',
  'auth.forgot.text': 'We will send a recovery instruction to the registered email if the account exists.',
  'auth.submitForgot': 'Send instruction',
  'auth.forgot.sent': 'If the account exists, an instruction was sent to {email}',
  'auth.pending.title': 'Request under review',
  'auth.pending.text': "Your email is verified. Your request has been submitted to the platform owner. We will email you the decision.",
  'auth.denied.title': 'Access denied',
  'auth.denied.text': 'Your role does not have permission to view this section.',
  'auth.error.email': 'Enter a valid email',
  'auth.error.password':
    'Your password must contain at least 6 characters, including at least one uppercase letter, one lowercase letter, one digit and one special character, such as !, @, #, $, %, &, *, ?, _ or -.',
  'auth.error.passwordRequired': 'Enter a password',
  'auth.error.passwordMatch': 'Passwords do not match',
  'auth.error.invalidCredentials': "Incorrect email / ID or password",
  'auth.password.show': 'Show password',
  'auth.password.hide': 'Hide password',
  'auth.password.rule.length': 'At least 6 characters',
  'auth.password.rule.upper': 'One uppercase letter',
  'auth.password.rule.lower': 'One lowercase letter',
  'auth.password.rule.digit': 'One digit',
  'auth.password.rule.special': 'One special character (! @ # $ % & * ? _ -)',
  'auth.password.rule.match': 'Passwords match',
  'auth.invite.title': 'Create a password',
  'auth.invite.text': 'After you open the link, create your password. The link is valid for 7 days.',
  'auth.invite.confirm': 'Confirm password',
  'auth.invite.submit': 'Accept invitation',
  'auth.invite.invalid': 'This link is invalid or has already been used',
  'auth.invite.expired': 'This invitation has expired',
  'auth.invite.revoked': 'This link is invalid or has already been used',
  'auth.invite.otherSession':
    'This invitation is for {email}. Another account is currently signed in. Sign out before creating the password.',
  'auth.invite.switch': 'Sign out and continue',
  'auth.error.confirm': 'Confirm your email address',
  'auth.signedIn': 'Signed in as {name}',
  'auth.signedOut': 'You signed out',
  'auth.registered': 'Access request sent to the owner',
  'auth.access.title': 'Request access',
  'auth.access.text':
    'This is an access request, not automatic registration. First select the requested category.',
  'auth.access.pickCategory': 'Select a category',
  'auth.access.changeCategory': 'Change category',
  'auth.access.category': 'Category',
  'auth.access.admissionYear': 'Admission year',
  'auth.access.program': 'Study program',
  'auth.access.period': 'Admission period',
  'auth.access.level': 'Education level',
  'auth.access.specialty': 'Specialty',
  'auth.access.verifySent': 'Verification email sent',
  'auth.access.verifySentDev': 'Verification created — open the link below if the email did not arrive',
  'auth.access.verifyHint': 'Confirm {email}. Request code: {code}.',
  'auth.access.openVerifyLink': 'Open verification link',
  'auth.access.checkStatus': 'Check verification',
  'auth.access.resend': 'Resend verification email',
  'auth.access.startOver': 'Start over',
  'auth.access.emailVerified': 'Email verified',
  'auth.access.readyHint': "Email verified. Request {code} is ready to submit to the platform owner.",
  'auth.access.submit': "Submit request",
  'auth.access.goPending': 'Go to pending screen',

  'portal.title': 'Публичный портал',
  'portal.subtitle': 'Zertteu Academy · Public Portal',
  'portal.about.title': 'О нас',
  'portal.about.text': 'Публичный раздел с описанием миссии, структуры и принципов платформы.',
  'portal.about.badge': 'KZ · RU · EN',
  'portal.about.mission': 'Миссия',
  'portal.about.missionText':
    'Объединить исследования, образование, академические возможности и профессиональную коммуникацию в одной среде.',
  'portal.about.structure': 'Структура',
  'portal.about.structureText':
    'Публичный информационный слой работает отдельно от закрытых ролевых кабинетов.',
  'portal.about.principles': 'Принципы',
  'portal.about.principlesText':
    'Проверяемость источников, ролевой доступ, приватность, версионирование документов.',
  'portal.news.title': 'Новости',
  'portal.news.text': 'Общая лента платформы и новости науки.',
  'portal.news.badge': 'Обновляется',
  'portal.news.1': 'Открыт приём тезисов конференции',
  'portal.news.1Text': 'Регистрация продлена до конца месяца.',
  'portal.news.2': 'Новое исследование в области лингвистики',
  'portal.news.2Text': 'Опубликованы предварительные результаты проекта.',
  'portal.news.3': 'Обновлён модуль аналитики публикаций',
  'portal.news.3Text': 'Добавлены новые графики и фильтры.',
  'portal.news.pill.platform': 'Событие платформы',
  'portal.news.pill.science': 'Наука',
  'portal.news.pill.update': 'Обновление системы',
  'portal.competitions.title': 'Конкурсы',
  'portal.competitions.text': 'Поиск и фильтры по направлению, уровню, месту и формату.',
  'portal.competitions.badge': '5 направлений',
  'portal.filter.searchPlaceholder': 'Название или тип',
  'portal.filter.direction': 'Направление',
  'portal.filter.level': 'Уровень',
  'portal.filter.city': 'Город',
  'portal.filter.cityPlaceholder': 'Астана, Алматы...',
  'portal.filter.category': 'Категория',
  'portal.filter.allLevels': 'Все уровни',
  'portal.level.national': 'Республиканский',
  'portal.level.international': 'Международный',
  'portal.direction.science': 'Образование и наука',
  'portal.direction.culture': 'Культура и искусство',
  'portal.competitions.1': 'Конкурс молодых учёных 2026',
  'portal.competitions.1Meta': 'Дедлайн: 30.09.2026 · Астана · Онлайн',
  'portal.competitions.2': 'Конференция цифровой лингвистики',
  'portal.competitions.2Meta': 'Дедлайн: 15.10.2026 · Алматы · Hybrid',
  'portal.materials.title': 'Материалы',
  'portal.materials.text':
    'Объявления, образцы документов, тесты, книги, журналы и сборники конференций.',
  'portal.materials.badge': 'Searchable',
  'portal.materials.searchPlaceholder': 'Название, тип или тема',
  'portal.materials.category.announcements': 'Объявления',
  'portal.materials.category.templates': 'Образцы документов',
  'portal.materials.category.books': 'Книги и пособия',
  'portal.materials.category.journals': 'Журналы',
  'portal.materials.1': 'Шаблон заявки на грант',
  'portal.materials.1Meta': 'Актуальная форма для подачи заявки.',
  'portal.materials.2': 'Методология научного письма',
  'portal.materials.2Meta': 'Пособие для докторантов и авторов.',
  'portal.materials.3': 'Вестник академии, выпуск 12',
  'portal.materials.3Meta': 'Сборник статей за текущий квартал.',
  'portal.education.title': 'Образование',
  'portal.education.text': 'Учебные заведения, гранты, стажировки, курсы и центры.',
  'portal.education.1': 'Гранты и стипендии',
  'portal.education.1Text': 'Каталог актуальных программ поддержки исследователей.',
  'portal.education.2': 'Стажировки',
  'portal.education.2Text': 'Возможности для докторантов и молодых учёных.',
  'portal.education.3': 'Курсы и мастер-классы',
  'portal.education.3Text': 'Программы повышения квалификации.',
  'portal.vacancies.title': 'Вакансии',
  'portal.vacancies.text': 'Академические и профессиональные возможности.',
  'portal.vacancies.1': 'Аналитик данных',
  'portal.vacancies.1Meta': 'Отдел цифровых сервисов, полная занятость.',
  'portal.vacancies.2': 'Научный редактор',
  'portal.vacancies.2Meta': 'Редакция журнала, частичная занятость.',
  'portal.vacancies.pill.it': 'IT',
  'portal.vacancies.pill.science': 'Наука',
  'portal.instructions.title': 'Инструкция по платформе',
  'portal.instructions.text': 'Как начать работу и найти нужный раздел.',
  'portal.instructions.1': '01 · Быстрый старт',
  'portal.instructions.1Text':
    'Войдите в кабинет → используйте меню сверху → выполняйте действия через карточки своей роли.',
  'portal.instructions.2': '02 · Текущая роль',
  'portal.instructions.2Text': 'Активная роль определяет доступ к рабочим данным.',
  'portal.instructions.3': '03 · Поддержка',
  'portal.instructions.3Text': 'Используйте AI-консультанта или форму обращения.',
  'portal.contacts.title': 'Контакты',
  'portal.contacts.text': 'Форма обращения без раскрытия приватных данных.',
  'portal.contacts.1': 'Общие обращения',
  'portal.contacts.1Text': 'Форма обращения к платформе.',
  'portal.contacts.2': 'Академическое сотрудничество',
  'portal.contacts.2Text': 'Предложения по исследованиям и партнёрству.',
  'portal.contacts.3': 'Техническая поддержка',
  'portal.contacts.3Text': 'Опишите роль, экран и действие.',

  'publisher.hub.title': 'Опубликовать контент',
  'publisher.hub.subtitle': 'Три направления публикации',
  'publisher.hub.direction.academia': 'Publish to ACADEMIA',
  'publisher.hub.direction.academia.desc': 'News, poll, achievement or event for the platform feed',
  'publisher.hub.direction.catalog': 'Add to public catalog',
  'publisher.hub.direction.catalog.desc': 'Competition, material, education or vacancy for public search',
  'publisher.hub.direction.social': 'Hand off to social / ENU site',
  'publisher.hub.direction.social.desc': 'Material for Instagram, ENU website or another channel',
  'publisher.kind.NEWS': 'Новость',
  'publisher.kind.QUICK_POLL': 'Быстрый опрос',
  'publisher.kind.ACHIEVEMENT': 'Достижение',
  'publisher.kind.EVENT': 'Событие',
  'publisher.kind.COMPETITION': 'Конкурс',
  'publisher.kind.MATERIAL': 'Материал',
  'publisher.kind.EDUCATION': 'Образование',
  'publisher.kind.VACANCY': 'Вакансия',
  'publisher.field.title': 'Заголовок',
  'publisher.field.summary': 'Краткое описание',
  'publisher.field.body': 'Полное описание',
  'publisher.field.organization': 'Организация',
  'publisher.field.category': 'Категория',
  'publisher.field.deadline': 'Дедлайн подачи',
  'publisher.field.eventStart': 'Начало события',
  'publisher.field.eventEnd': 'Конец события',
  'publisher.field.officialUrl': 'Официальная ссылка',
  'publisher.field.language': 'Язык контента',
  'publisher.field.audience': 'Аудитория',
  'publisher.field.level': 'Уровень',
  'publisher.field.formatType': 'Формат',
  'publisher.field.city': 'Город',
  'publisher.field.country': 'Страна',
  'publisher.field.direction': 'Направление',
  'publisher.field.costType': 'Стоимость',
  'publisher.field.employmentType': 'Занятость',
  'publisher.field.requirements': 'Требования',
  'publisher.field.conditions': 'Условия',
  'publisher.field.contactEmail': 'Email для связи',
  'publisher.field.salary': 'Зарплата/стипендия',
  'publisher.field.hashtags': 'Хэштеги (3–5)',
  'publisher.field.hashtags.hint': 'Добавьте от 3 до 5 хэштегов',
  'publisher.field.pollOptions': 'Варианты ответа',
  'publisher.field.addOption': '+ Добавить вариант',
  'publisher.field.allowMultiple': 'Множественный выбор',
  'publisher.field.achievementType': 'Тип достижения',
  'publisher.field.participants': 'Участники',
  'publisher.field.captionDraft': 'Черновик подписи',
  'publisher.field.channels': 'Каналы',
  'publisher.field.materialType': 'Тип материала',
  'publisher.field.fileFormat': 'Формат файла',
  'publisher.field.accessType': 'Доступ',
  'publisher.field.publisherName': 'Издатель',
  'publisher.field.publishYear': 'Год издания',
  'publisher.status.DRAFT': 'Черновик',
  'publisher.status.SUBMITTED_FOR_MODERATION': 'На модерации',
  'publisher.status.CHANGES_REQUESTED': 'Нужны правки',
  'publisher.status.PUBLISHED': 'Опубликовано',
  'publisher.status.AUTO_PUBLISHED': 'Автоопубликовано',
  'publisher.status.ARCHIVED': 'Архив',
  'publisher.action.saveDraft': 'Сохранить черновик',
  'publisher.action.submitModeration': 'Отправить на модерацию',
  'publisher.action.publishNow': 'Опубликовать сейчас',
  'publisher.action.preview': 'Предпросмотр',
  'publisher.action.back': '← Назад',
  'publisher.toast.draftSaved': 'Черновик сохранён',
  'publisher.toast.submitted': 'Отправлено на модерацию',
  'publisher.toast.published': 'Опубликовано',
  'publisher.validation.tags.min': 'Добавьте минимум 3 хэштега',
  'publisher.validation.tags.max': 'Максимум 5 хэштегов',
  'publisher.validation.officialUrl.required': 'Официальная ссылка обязательна для внешних источников',
  'publisher.disclaimer.catalog': 'Информация взята из официального источника. Zertteu Academy не несёт ответственности за актуальность данных.',
  'publisher.social.type.event': 'Событие',
  'publisher.social.type.achievement': 'Достижение',
  'publisher.social.type.announcement': 'Объявление',
  'publisher.social.type.publication': 'Публикация',
  'publisher.social.channel.instagram': 'Instagram',
  'publisher.social.channel.site': 'Сайт ENU',
  'publisher.social.channel.telegram': 'Telegram',
  'publisher.my.title': 'Мои публикации',
  'publisher.my.empty': 'Публикаций нет',

  'portal.home.hero.title': 'Zertteu Academy · Публичный портал',
  'portal.home.hero.subtitle': 'Открытая платформа для академического сообщества',
  'portal.home.latestFeed': 'Лента новостей',
  'portal.home.opportunities': 'Новые возможности',
  'portal.home.materials': 'Новые материалы',
  'portal.home.important': 'Важное',
  'portal.home.popularTags': 'Популярные темы',
  'portal.home.viewAll': 'Смотреть все →',

  'portal.detail.source': 'Источник',
  'portal.detail.official': 'Официальный источник',
  'portal.detail.deadline': 'Дедлайн',
  'portal.detail.eventDate': 'Дата события',
  'portal.detail.level': 'Уровень',
  'portal.detail.format': 'Формат',
  'portal.detail.city': 'Город',
  'portal.detail.direction': 'Направление',
  'portal.detail.cost': 'Стоимость',
  'portal.detail.employment': 'Занятость',
  'portal.detail.requirements': 'Требования',
  'portal.detail.conditions': 'Условия',
  'portal.detail.contact': 'Контакт',
  'portal.detail.disclaimer': 'Данные взяты из открытых источников. Проверяйте актуальность на официальном сайте.',
  'portal.detail.save': 'Сохранить',
  'portal.detail.saved': 'Сохранено ✓',
  'portal.detail.openSource': 'Открыть источник →',
  'portal.detail.share': 'Поделиться',
  'portal.detail.votePoll': 'Проголосовать',
  'portal.detail.pollClosed': 'Голосование завершено',
  'portal.detail.participants': 'Участников',
  'portal.detail.back': '← Все записи',
  'portal.detail.views': 'просмотров',

  'portal.filter.all': 'Все',
  'portal.filter.noResults': 'Ничего не найдено',
  'portal.filter.resetFilters': 'Сбросить фильтры',
  'portal.filter.sort': 'Сортировка',
  'portal.filter.sort.new': 'Сначала новые',
  'portal.filter.sort.popular': 'Популярные',
  'portal.filter.sort.deadline': 'По дедлайну',
  'portal.filter.deadline': 'Дедлайн',
  'portal.filter.deadline.active': 'Активные',
  'portal.filter.deadline.7d': 'До 7 дней',
  'portal.filter.deadline.30d': 'До 30 дней',
  'portal.filter.deadline.expired': 'Истёкшие',
  'portal.filter.cost': 'Стоимость',
  'portal.filter.cost.free': 'Бесплатно',
  'portal.filter.cost.paid': 'Платно',
  'portal.filter.employment': 'Занятость',
  'portal.filter.format': 'Формат',
  'portal.filter.format.online': 'Онлайн',
  'portal.filter.format.offline': 'Оффлайн',
  'portal.filter.format.hybrid': 'Гибрид',
  'portal.filter.filters': 'Фильтры',
  'portal.filter.apply': 'Применить',

  'portal.moderation.title': 'Очередь модерации',
  'portal.moderation.pending': 'Ожидают',
  'portal.moderation.approvedToday': 'Одобрено сегодня',
  'portal.moderation.rejected': 'Отклонено',
  'portal.moderation.approve': 'Одобрить',
  'portal.moderation.changes': 'Нужны правки',
  'portal.moderation.reject': 'Отклонить',
  'portal.moderation.comment': 'Комментарий к решению',
  'portal.moderation.decision': 'Принять решение',
  'portal.moderation.empty': 'Очередь пуста',

  'portal.sources.title': 'Официальные источники',
  'portal.sources.addSource': '+ Добавить источник',
  'portal.sources.name': 'Название',
  'portal.sources.domain': 'Домен',
  'portal.sources.kinds': 'Типы контента',
  'portal.sources.status': 'Статус',
  'portal.sources.lastFetch': 'Последний сбор',
  'portal.sources.testFetch': 'Тест подключения',
  'portal.sources.pause': 'Приостановить',
  'portal.sources.block': 'Заблокировать',
  'portal.sources.activate': 'Активировать',
  'portal.sources.status.ACTIVE': 'Активен',
  'portal.sources.status.PAUSED': 'Приостановлен',
  'portal.sources.status.ERROR': 'Ошибка',
  'portal.sources.status.BLOCKED': 'Заблокирован',

  'portal.colab.title': 'Автосбор источников',
  'portal.colab.lastRun': 'Последний запуск',
  'portal.colab.nextRun': 'Следующий запуск',
  'portal.colab.sourcesChecked': 'Проверено источников',
  'portal.colab.itemsFound': 'Найдено материалов',
  'portal.colab.itemsPublished': 'Опубликовано',
  'portal.colab.duplicates': 'Дубликаты',
  'portal.colab.reviewRequired': 'Требуют проверки',
  'portal.colab.sourcesErrors': 'С ошибками',
  'portal.colab.runNow': 'Запустить сейчас',
  'portal.colab.running': 'Запуск...',
  'portal.colab.duration': 'Время выполнения',
  'portal.colab.neverRun': 'Ещё не запускался',
  'portal.colab.schedule': 'Расписание: 04:00 Asia/Almaty',

  'portal.social.title': 'Соцсети / ENU',
  'portal.social.new': 'Новая передача',
  'portal.social.status.SUBMITTED': 'Подано',
  'portal.social.status.IN_REVIEW': 'На проверке',
  'portal.social.status.NEEDS_INFO': 'Нужна информация',
  'portal.social.status.PREPARED': 'Готово к публикации',
  'portal.social.status.SENT_TO_CHANNEL': 'Отправлено',
  'portal.social.status.PUBLISHED': 'Опубликовано',
  'portal.social.status.CLOSED': 'Закрыто',

  'portal.cms.about.mission': 'Миссия',
  'portal.cms.about.structure': 'Структура',
  'portal.cms.about.founder': 'О создателе',
  'portal.cms.about.achievements': 'Достижения',
  'portal.cms.about.legal': 'Нормативная база',
  'portal.cms.about.partners': 'Партнёры',
  'portal.cms.instruction.quickStart': 'Быстрый старт',
  'portal.cms.instruction.roles': 'Роли и кабинеты',
  'portal.cms.instruction.faq': 'Частые вопросы',
  'portal.cms.instruction.support': 'Поддержка',
  'portal.cms.contacts.general': 'Общие обращения',
  'portal.cms.contacts.academic': 'Академическое сотрудничество',
  'portal.cms.contacts.technical': 'Техническая поддержка',

  'footer.rights': '© {year} Zertteu Academy',

  'error.title': 'Что-то пошло не так',
  'error.text': 'Обновите страницу или вернитесь на главную.',
  'error.retry': 'Обновить',
  'error.notFoundTitle': 'Страница не найдена',
  'error.notFoundText': 'Похоже, такой раздел ещё не создан или адрес указан неверно.',
  'error.toHome': 'На главную',

  // 02.05 · Все пользователи · Роли и доступы
  'admin.users.field.roles': "Roles",
  'admin.users.field.categories': "Categories",
  'admin.users.field.firstName': "First name",
  'admin.users.field.lastName': "Last name",
  'admin.users.field.position': "Position",
  'admin.users.field.department': "Department",
  'admin.users.field.createdAt': "Date added",
  'admin.users.field.lastLogin': "Last sign-in",
  'admin.users.field.statusNote': "Reason",
  'admin.users.field.user': "User",
  'admin.users.field.status': "Status",
  'admin.users.field.actions': "Actions",
  'admin.users.field.submittedAt': "Request date",

  'admin.users.modal.open': "User details",
  'admin.users.modal.edit': "Edit user",
  'admin.users.modal.status': "Account status",
  'admin.users.modal.message': "Private message",
  'admin.users.modal.invitation': "Invitation",
  'admin.users.modal.history': "Change history",
  'admin.users.modal.add': "Add user",
  'admin.users.modal.bulk': "Add users in bulk",
  'admin.users.modal.approve': "Approve request",
  'admin.users.modal.reject': "Reject request",

  'admin.users.status.ACTIVE': "Active",
  'admin.users.status.INVITED': "Invited",
  'admin.users.status.SUSPENDED': "Suspended",
  'admin.users.status.ARCHIVED': "Archived",
  'admin.users.status.current': "Current status",
  'admin.users.status.none': "No actions available for this status",
  'admin.users.status.reason': "Reason / comment",
  'admin.users.status.archiveConfirm': "I confirm archiving this account",
  'admin.users.status.action.suspend': "Suspend",
  'admin.users.status.action.archive': "Archive",
  'admin.users.status.action.reactivate': "Reactivate",
  'admin.users.status.action.restore': "Restore from archive",

  'admin.users.soleOwner': "· sole owner",
  'admin.users.soleOwnerHint': "The sole system owner cannot be suspended, archived or removed",

  'admin.users.toast.updated': "Changes saved",
  'admin.users.toast.statusChanged': "Status updated",
  'admin.users.toast.messageSent': "Message sent",
  'admin.users.toast.invitationSent': "Invitation sent",
  'admin.users.toast.invitationRevoked': "Invitation revoked",
  'admin.users.toast.created': "User created and invitation sent",
  'admin.users.toast.accessApproved': "Request approved and invitation sent",
  'admin.users.toast.accessRejected': "Request rejected",

  'admin.users.message.to': "To",
  'admin.users.message.subject': "Subject",
  'admin.users.message.body': "Message",
  'admin.users.message.send': "Send",

  'admin.users.invitation.expires': "Valid until",
  'admin.users.invitation.revoke': "Revoke",
  'admin.users.invitation.resend': "Resend",
  'admin.users.invitation.none': "No invitation has been sent",
  'admin.users.invitation.notDelivered': "Not delivered",
  'admin.users.invitation.sentUnverified': "Email sent. The address remains unverified until the invitation is accepted.",
  'admin.users.invitation.acceptedVerified': "Address verified: invitation accepted.",

  'admin.users.add.email': 'Email',
  'admin.users.add.checkEmail': "Check email",
  'admin.users.add.submit': 'Send invitation',
  'admin.users.add.educationRequired':
    'Choose an education level for “Supervised student”. If there is no research supervisor yet, leave “Not assigned”.',
  'admin.users.field.accessCategories': "Access categories",
  'admin.users.field.notAssigned': "Not assigned",
  'admin.users.toast.resent': "Invitation resent. Academia ID is unchanged.",
  'admin.users.toast.emailFailed': "The email could not be sent. Please try again.",
  'admin.users.toast.notDelivered': "Not delivered. The address has not been marked as verified.",
  'admin.users.toast.emailNotConfigured': "Invitation saved. Email is not configured, so the message was not sent. Try again later.",
  'admin.users.toast.createdEmailFailed': "User created, but the email could not be sent. Resend from user details.",
  'admin.users.toast.createdEmailQueued': "User created. Email was not sent because the mail service is not configured.",

  'admin.users.bulk.addRow': "Add row",
  'admin.users.bulk.precheck': "Check list",
  'admin.users.bulk.commit': "Create users",
  'admin.users.bulk.status': "Result",
  'admin.users.bulk.committed': "Users created: {count}",

  'admin.users.action.bulkAdd': "Add users in bulk",
  'admin.users.action.addUser': "Add user",
  'admin.users.action.open': "Open",
  'admin.users.action.edit': "Edit",
  'admin.users.action.status': "Status",
  'admin.users.action.message': "Message",
  'admin.users.action.invitation': "Invitation",
  'admin.users.action.history': "History",

  'admin.users.filter.search': "Search by name, email or Academia ID",
  'admin.users.filter.allCategories': "All categories",
  'admin.users.filter.allStatuses': "All statuses",

  'admin.users.kpi.total': "Total users",
  'admin.users.kpi.activeCategories': "Active categories",
  'admin.users.kpi.multiRole': "Multiple roles",
  'admin.users.kpi.addedToday': "Added today",
  'admin.users.kpi.pendingRequests': "Access requests",
  'admin.users.kpi.suspended': "Suspended",
  'auth.verify.title': "Verify email",
  'auth.verify.ready': "Select the button to verify your email. Verification does not grant access to the workspaces.",
  'auth.verify.confirm': "Verify email",
  'auth.verify.confirmed': "Your email is verified. You can submit your request to the platform owner.",
  'auth.verify.invalid': "This link is invalid or has expired.",
  'auth.verify.back': "Back to request",
  'auth.reset.title': "New password",
  'auth.reset.text': "Create a new password to sign in.",
  'auth.reset.saved': "Password updated. Sign in with your new password.",
  'auth.reset.failed': "Could not update the password. Request a new link.",
  'auth.reset.save': "Save password",
  'auth.password.rulesHint': "Use Latin letters A–Z and a–z, digits 0–9 and one of ! @ # $ % & * ? _ -. Enter the password again to confirm it. Length: 6–128 characters.",
  'admin.users.toast.approvedUnsent': "Request approved, but the invitation was not sent. Resend from user details.",
  'admin.users.bulk.READY': "Ready",
  'admin.users.bulk.EXISTING': "Already exists",
  'admin.users.bulk.CONFLICT': "Conflict",
  'admin.users.bulk.ERROR': "Error",
  'auth.access.seconds': "s",
} as const;

export type TranslationKey = keyof typeof en;
